module.exports = __webpack_public_path__ + "static/media/off_centered.1612f676.svg";